// extracted by mini-css-extract-plugin
export var page = "pageLiked-module--page--5XgH2";
export var d1 = "pageLiked-module--d1--E2Bar";
export var flexTop = "pageLiked-module--flexTop--c1bQs";
export var postReads = "pageLiked-module--postReads--N8Hs5";
export var likes = "pageLiked-module--likes--Aa3XT";
export var d2 = "pageLiked-module--d2--M0qnO";
export var thanks = "pageLiked-module--thanks--UyQH-";